//Config file for 2026 season rebuild

/**
 * The option for QATA Quick Questions
 */
export const qataQuestions2026 = {
    auto: [
        {
            question: "Climb Side",
            options: ["Left", "Middle", "Right", "Back"]
        }
    ],
    tele: [
        // Star ratings, half stars allowed (user, Oct 2026); saved as "Driver skill: 3.5/5 stars,"
        {
            question: 'Drive Train Speed:',
            options: [],
            isStars: true
        },
        {
            question: 'Driver skill:',
            options: [],
            isStars: true
        },
        {
            question: "Shooting Location",
            options: ['Outpost', 'Depot', '3ft from hub', '6ft from hub']
        },
        {
            question: "Feeding Location",
            options: ['Before Midline', 'After Midline']
        },
        {
            question: 'Climb time:',
            options: [],
            isNumber: true
        },
        {
            question: 'What does the robot do during inactive period?',
            options: [],
            isInput: true
        },
    ]
};

/**
 * Holds all information for the info page
 * For structure:
 * Title: name of the section
 * Info: array holding the different subsections in the main section
 * Subtitle: Name of the subsection
 * Text: the text in that subsection
 */
export const additionalInfoObject2026 = {
    qata :{
        title: "What is QATA",
        info: [
            {
                subtitle: "What is it?",
                text: (
                    <>
                        QATA refers to data that cannot be expressed with numbers and provides context for quantitative data. 
                        To enter QATA while scouting, press <em>Alt</em> (left) to open a text box, or on mobile, tap the team number area button. For defense notes, press <em>Right Alt</em> or tap <em>Right Shift</em>, or tap the timer.
                    </>
                )
            },
            {
                subtitle: "Examples",
                text: (
                    <>
                        Things to write about in auto include: starting position (middle, proc side, cage side) and reasons for any auto failures.
                        Things to write about in teleop include: drivetrain speed, 
                        and driver skill. Additionally writing about any else that occured in the match that gives context
                        is helpful.
                    </>
                )
            }
        ]
    },
    auto_buttons: {
        title: "Data Buttons: Auto",
        info: [       
        {
            subtitle: "Leave",
            text: (
            <>
                When a robot leaves the starting line in auto.{" "}
                <span style={{ textDecoration: "underline" }}>
                Robot must be off the starting line at the{" "}
                <span style={{ fontWeight: "bold" }}>end</span> of auto{" "}
                to count. If they leave temporarily then return to the start line
                it no longer counts for the point.
                </span>
            </>
            ),
        },
        ],
    },
    tele_buttons: {
        title: "Data Buttons: Teleop",
        info: [
        {
            subtitle: "Oof Time",
            text: (
            <>
                Oof Time corresponds to how much time the robot spends incapable of
                moving due to a robot error or incapable of scoring due to mechanism
                failure/jamming.{" "}
                <span style={{ fontWeight: "bold" }}>
                (An opposing robot pinning the robot does NOT count as oof time).
                </span>{" "}
                Clicking it will start a stopwatch. When a robot gets back online,
                click to stop the stopwatch.
            </>
            ),
        },
        {
            subtitle: "Defend Time",
            text: (
            <>
                A timer to keep track of when the robot is defending others. Defense
                counts as active disruption in opponents' scoring cycles.
            </>
            ),
        },
        ],
    },
};


/**
 * For maxlength: if its an int maxlength is the value, if string its the length
 */




/**
 * make sure the stuff in here matches whats in the mainSettings const
 */
export const startScoutPage2026 = {
    match_number :{
        label: "match_number",
        display: "Match Number",
        writeType: "int",
        placeholder: "Current match #",
        maxLength:"999"
    },
    team_number :{
        label: "team_number",
        display: "Team Number",
        writeType: "int",
        placeholder: "# of the team you are scouting",
        maxLength:"13000"
    },
}


/**
 * make sure the stuff in here matches whats in the mainSettings const
 */
export const initialPage2026 = {
    event_path :{
        label: "event_path",
        display: "Event Path",
        writeType: "str",
        placeholder: "The tba event code",
        maxLength:"20"
        
    },
    scout_id :{
        label: "scout_id",
        display: "Scout ID",
        writeType: "str",
        placeholder: "Your Name",
        maxLength:"20"
    },
    scout_team :{
        "label": "scout_team",
        "display": "Scout Team",
        "writeType": "int",
        "placeholder": "The Scouter's Team Number",
        "maxLength":"13000"
    },
    team_position : {
        label: "team_position",
        display: "Team Position",
        writeType: "int",
        placeholder: "1, 2, or 3",
        maxLength:"3"
    },
    alliance_color : {
        label: "alliance_color",
        display: "Alliance Color",
        writeType: "str",
        placeholder: "Click to Set Color",
        maxLength:"4"
    }
};


/**
 * The different writeTypes:
 *      bool: boolean value
 *      inc: a timer
 *      tog: toggles a timer that gets added to an array
 *      cycG: cycles through numerical options
 *      int: integer value
 * 
 * 
 * Just a little note
 * event_path is hardcoded in both tabs/Home and components/Eventinput
 * scout_team is hardcoded in tabs/Home
 * allaince_color is hardcoded in both tabs/Home and tabs/Scout (for the post match section)
 * 
 * basically dont mess with any of the "start" section datapoints bc it might screw with something somewhere
 * that goes for the ones in initialPage and startScoutPage as well
 * anything else is fair game to change
 */
export const gridSettings2026 = {
    "auto": {
        "rc": 6
    },
    "tele": {
        "rc": 4
    }
}
export const mainSettings2026 = {
    "imported": {
        "transitionMode": "auto"
    },
        "auto": [        
        {
            "label": "start_pos",
            "display": "🏁 Start",
            "trigger": "s",
            "columnStart": 1,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "cycG",
            "cycGOptions": ["N/A", "Outpost-Trench","Outpost-Bump","Middle","Depot-Trench", "Depot-Bump"]
        },
        {
            "label": "auto_scoring_intervals",
            "display": "🟡 Shooting Toggle",
            "trigger": "q",
            "columnStart": 1,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "tog"
        },
        {
            "label": "auto_feeding_intervals",
            "display": "🥄 Feeding Toggle",
            "trigger": "w",
            "columnStart": 1,
            "columnEnd": 5,
            "rowStart": 2,
            "rowEnd": 3,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "tog"
        },
        {
            "label": "auto_climb",
            "display": "🪜 Climb",
            "trigger": "j",
            "columnStart": 1,
            "columnEnd": 5,
            "rowStart": 4,
            "rowEnd": 5,
            "rowStart": 5,
            "rowEnd": 6,
            "writeType": "cycG",
            "cycGOptions": [0, 15]
        },
        {
            "label": "auto_accuracy",
            "display": "🎯 Accuracy",
            "trigger": "c",
            "columnStart": 1,
            "columnEnd": 5,
            "rowStart": 3,
            "rowEnd": 4,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "cycG",
            "cycGOptions": ["N/A", 1.0, 0.95, 0.9, 0.85, 0.8, 0.75, 0.7, 0.65, 0.6, 0.55, 0.5, 0.45, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15, 0.1, 0.05, 0]
        },
    ],
    "tele": [
        {
            "label": "tele_scoring_intervals",
            "display": "🟡 Shooting Toggle",
            "trigger": "q",
            "columnStart": 1,
            "columnEnd": 3,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "tog"
        },
        {
            "label": "tele_feeding_intervals",
            "display": "🥄 Feeding Toggle",
            "trigger": "w",
            "columnStart": 3,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "tog"
        },
        {
            "label": "defended_time",
            "display": "🛡️ Defended Time",
            "trigger": "e",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "inc"
        },
        {
            "label": "attacking_time",
            "display": "⚔️ Attacking",
            "trigger": "r",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "inc"
        },
        {
            "label": "tele_accuracy",
            "display": "🎯 Accuracy",
            "trigger": "c",
            "columnStart": 1,
            "columnEnd": 3,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "cycG",
            "cycGOptions": ["N/A", 1.0, 0.95, 0.9, 0.85, 0.8, 0.75, 0.7, 0.65, 0.6, 0.55, 0.5, 0.45, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15, 0.1, 0.05, 0]
        },
        {
            "label": "oof_time",
            "display": "🚑 Oof Time",
            "trigger": "b",
            "columnStart": 3,
            "columnEnd": 5,
            "rowStart": 3,
            "rowEnd": 5,
            "writeType": "inc"
        },
        {
            "label": "cross_bump",
            "display": "⛰️ Bump",
            "trigger": "f",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "bool"
        },
        {
            "label": "cross_trench",
            "display": "🧥 Trench",
            "trigger": "g",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "bool"
        },
        {
            "label": "tele_climb",
            "display": "🪜 Climb Level",
            "trigger": "j",
            "columnStart": 1,
            "columnEnd": 3,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "cycG",
            "cycGOptions": [0, 10, 20, 30]

        },

    ],
    "after": [
        {
            "label": "auto_qata",
            "display": "Auto QATA",
            "writeType": "str",
            "placeholder": "e.g. speed? path? starting location?"
        },
        {
            "label": "qata",
            "display": "Tele QATA",
            "writeType": "str",
            "placeholder": "e.g. how are they scoring? speed? skill?"
        },
        {
            "label": "defense_qata",
            "display": "Defense QATA",
            "writeType": "str",
            "placeholder": "how did they play defense? push power? speed?"
        }
    ],
    "start": [
        {
            "label": "scout_id",
            "display": "Scout ID",
            "writeType": "str",
            "placeholder": "Your Name",
            "maxLength":"20"
        },
        {
            "label": "scout_team",
            "display": "Scout Team",
            "writeType": "int",
            "placeholder": "The scouter's team number",
            "maxLength":"13000"
        },
        {
            "label": "team_position",
            "display": "Team Position",
            "writeType": "int",
            "placeholder": "1, 2, or 3",
            "maxLength":"3"
        },
        {
            "label": "match_number",
            "display": "Match Number",
            "writeType": "int",
            "placeholder": "Current match #",
            "maxLength":"999"
        },
        {
            "label": "team_number",
            "display": "Team Number",
            "writeType": "int",
            "placeholder": "# of the team you are scouting",
            "maxLength":"13000"
        },
        {
            "label": "alliance_color",
            "display": "Alliance Color",
            "writeType": "str",
            "placeholder": "Click to Set Color",
            "maxLength":"4"
        }
    ]
}

export const extraDatapoints2026 = [
    "fuel_timestamps"
]

export const rebuiltMissTypeCount2026 = {
    "auto": [
        {
            "label": "auto_miss",
            "display": "🎯 Miss",
            "trigger": "c",
            "columnStart": 1,
            "columnEnd": 5,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "int",
        }
    ],
    "tele":[
        {
            "label": "tele_miss",
            "display": "🎯 Miss",
            "trigger": "c",
            "columnStart": 1,
            "columnEnd": 3,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int",
        }
    ]
}